<template>
  <div class="charts-container section pt-1 pb-2 pl-1 pr-1">
    <div class="block-one" v-if="content">
      <span class="title">{{ CONSTANTS.getCopy('CHARTS_TITLE_MORE_FREQUENTS') }}<span class="all" @click="showIntentsTableView(1)">
        {{ CONSTANTS.getCopy('CHARTS_TITLE_MORE_FREQUENTS_VIEW_ALL') }}</span></span>
      <table v-if="content.intentsFrequent.length" class="table is-fullwidth">
        <tr>
          <th>{{ CONSTANTS.getCopy('CHARTS_INTENTS_FREQUENTS_INTENT') }}</th>
          <th class="has-text-right">{{ CONSTANTS.getCopy('CHARTS_INTENTS_FREQUENTS_#') }}</th>
          <th class="has-text-right">{{ CONSTANTS.getCopy('CHARTS_INTENTS_FREQUENTS_RIGHT') }}</th>
          <th class="has-text-right">{{ CONSTANTS.getCopy('CHARTS_INTENTS_FREQUENTS_DOUBT') }}</th>
        </tr>
        <tr v-for="(intent, index) in content.intentsFrequent" :key="index">
          <td>{{ cutTableText(intent.name) }}</td>
          <td class="has-text-right total">{{ intent.total }}</td>
          <td class="has-text-right ok">{{ intent.percentOK }}%</td>
          <td class="has-text-right doubt">{{ intent.percentDuda }}%</td>
        </tr>
      </table>
      <div v-else class="no-data">{{ CONSTANTS.getCopy('CHARTS_INTENTS_FREQUENTS_NO_DATA') }}</div>
      <span class="title">{{ CONSTANTS.getCopy('CHARTS_INTENTS_FREQUENTS_NEED_REVISION') }}<span class="all"
          @click="showIntentsTableView(2)">{{ CONSTANTS.getCopy('CHARTS_INTENTS_FREQUENTS_NEED_REVISION_VIEW_ALL') }}</span></span>
      <table v-if="content.intentFeedbackKO.length" class="table is-fullwidth">
        <tr>
          <th>{{ CONSTANTS.getCopy('CHARTS_INTENT_TYPE2') }}</th>
          <th class="has-text-right">{{ CONSTANTS.getCopy('CHARTS_NEED_REVISION_TYPE2_#') }}</th>
          <th class="has-text-right">{{ CONSTANTS.getCopy('CHARTS_NEED_REVISION_TYPE2_GOOD') }}</th>
          <th class="has-text-right">{{ CONSTANTS.getCopy('CHARTS_NEED_REVISION_TYPE2_BAD') }}</th>
          <th class="has-text-right">{{ CONSTANTS.getCopy('CHARTS_NEED_REVISION_TYPE2_KO') }}</th>
        </tr>
        <tr v-for="(intent, index) in content.intentFeedbackKO" :key="index">
          <td>{{ cutTableText(intent.name) }}</td>
          <td class="has-text-right total">{{ intent.total }}</td>
          <td class="has-text-right total">{{ intent.rateOK }}</td>
          <td class="has-text-right total">{{ intent.rateKO }}</td>
          <td class="has-text-right ko">{{ intent.negative }}%</td>
        </tr>
      </table>
      <div v-else class="no-data">{{ CONSTANTS.getCopy('CHARTS_TYPE2_NO_DATA') }}</div>
    </div>
    <div class="block-two" v-if="content">
      <div class="header">
        <div><span class="title">{{ CONSTANTS.getCopy('CHARTS_HEADER_TITLE_EVOLUTION_MESSAGES') }}</span></div>
        <div class="chart-switch">
          <div :class="{ 'selected': showMessagesEvolution }" @click="toggleShowMessagesEvolution()">
            {{ CONSTANTS.getCopy('CHARTS_HEADER_EVOLUTION_MESSAGES') }}
          </div>
          <div :class="{ 'selected': !showMessagesEvolution }" @click="toggleShowMessagesEvolution()">
            {{ CONSTANTS.getCopy('CHARTS_HEADER_EVOLUTION_SUCCESS') }}
          </div>
        </div>
      </div>
      <div class="column-chart" v-if="!showMessagesEvolution">
        <GChart v-if="evolutionMessagesColumnChart.length > 1" type="ColumnChart" :data="evolutionMessagesColumnChart"
          :options="getChartOptions('evolution', 'Evolución sin mensajes descartados', 'percent')" />
        <div v-else class="no-data">{{ CONSTANTS.getCopy('CHARTS_EVOLUTION_NO_DATA_NO_DISCARDED_MESSAGES') }}</div>
      </div>
      <div class="column-chart" v-if="!showMessagesEvolution">
        <GChart v-if="evolutionDiscardedMessagesColumnChart.length > 1" type="ColumnChart"
          :data="evolutionDiscardedMessagesColumnChart"
          :options="getChartOptions('discarded', 'Evolución con mensajes descartados', 'percent')" />
        <div v-else class="no-data">{{ CONSTANTS.getCopy('CHARTS_EVOLUTION_NO_DATA_WITH_DISCARDED_MESSAGES') }}</div>
      </div>
      <div class="column-chart" v-if="showMessagesEvolution">
        <GChart v-if="totalEvolutionMessagesColumnChart.length > 1" type="ColumnChart"
          :data="totalEvolutionMessagesColumnChart" :options="getChartOptions('totalEvolution')" />
        <div v-else class="no-data">{{ CONSTANTS.getCopy('CHARTS_EVOLUTION_NO_DATA_TOTAL_EVOLUTION') }}</div>
      </div>
    </div>
    <div class="block-three" v-if="content">
      <div class="minutes">
        <span class="amount">{{ content.minutes }}</span>
        <span class="text">{{ CONSTANTS.getCopy('CHARTS_MINUTES_SAVED') }}</span>
      </div>
      <div class="interventions">
        <div>
          <span class="amount">{{ content.agents.agentsTotal }}</span>
          <span class="text">{{ CONSTANTS.getCopy('CHARTS_AGENTS_INTERVENTIONS') }}</span>
        </div>
        <hr>
        <div>
          <span class="amount">{{ content.agents.messagesTotal }}</span>
          <span class="text">{{ CONSTANTS.getCopy('CHARTS_TOTAL_AGENTS_MESSAGES') }}</span>
        </div>
        <div>
          <span style="text-transform: lowercase;cursor: pointer;" @click="showKpiAgentsView"><b>{{ CONSTANTS.getCopy('CHARTS_POINTER_VIEW_KPI') }}</b></span>
        </div>
      </div>
      <div class="messages">
        <span class="title">{{ CONSTANTS.getCopy('CHARTS_TITLE_MESSAGES_BY_PLATFORM') }}</span>
        <GChart v-if="platformMessagesPieData.length > 1" type="PieChart" :data="platformMessagesPieData"
          :options="getChartOptions('platform')" />
        <div v-else class="no-data">{{ CONSTANTS.getCopy('CHARTS_MESSAGES_BY_PLATFORM_NO_DATA') }}</div>
      </div>
    </div>
  </div>

</template>

<script>

import { GChart } from 'vue-google-charts'
import Strings from '../../lib/Strings'
import platformTypes from '../../lib/PlatformTypes'

export default {
  props: { content: Object },
  components: { GChart },
  data () {
    return {
      showMessagesEvolution: true,
      totalEvolutionMessagesColumnChart: [],
      evolutionMessagesColumnChart: [],
      evolutionDiscardedMessagesColumnChart: [],
      platformMessagesPieData: [],
      platformColors: []
    }
  },
  watch: {
    content () {
      this.initPlatforms()
      this.reloadData()
    }
  },
  methods: {
    initPlatforms () {
      this.platformMessagesPieData = [['Platform', 'Total']]
      this.platformTypes = platformTypes.platformTypes
    },
    reloadData () {
      this.setPlatformMessagesData()
      this.setEvolutionMessagesData()
      this.setEvolutionDiscardedMessagesData()
      this.setTotalEvolutionMessagesData()
    },
    getChartOptions (color, title = '', stacked = true) {
      const colors = {
        evolution: ['#0FC68F', '#E3DE6D', '#E38259'],
        discarded: ['#0FC68F', '#E3DE6D', '#E38259', '#3366CC'],
        totalEvolution: ['#499FF5'],
        platform: this.platformColors
      }

      const options = {
        width: '100%',
        height: 220,
        title: title,
        chartArea: { left: 35, right: 2 },
        colors: colors[color],
        isStacked: stacked
      }
      return options
    },
    toggleShowMessagesEvolution () {
      this.showMessagesEvolution = !this.showMessagesEvolution
    },
    showIntentsTableView (type) {
      this.$emit('showIntentsTableView', type)
    },
    setTotalEvolutionMessagesData () {
      this.totalEvolutionMessagesColumnChart = [['Date', 'Total']]
      this.totalEvolutionMessagesColumnChart = this.totalEvolutionMessagesColumnChart.concat(this.content.messagesEvolution.map(element => [
        element.date, element.total
      ]))
    },
    setEvolutionMessagesData () {
      this.evolutionMessagesColumnChart = [['Date', 'Bien', 'Duda', 'Error']]
      this.evolutionMessagesColumnChart = this.evolutionMessagesColumnChart.concat(this.content.messagesEvolution.map(element => [
        element.date, element.totalOK, element.totalDuda, element.totalError
      ]))
    },
    setEvolutionDiscardedMessagesData () {
      this.evolutionDiscardedMessagesColumnChart = [['Date', 'Bien', 'Duda', 'Error', 'Descartados']]
      this.evolutionDiscardedMessagesColumnChart = this.evolutionDiscardedMessagesColumnChart.concat(this.content.messagesEvolution.map((element) => {
        return [element.date, element.totalOK, element.totalDuda, element.totalError, element.totalDescartado]
      }))
    },
    setPlatformMessagesData () {
      this.platformMessagesPieData = this.platformMessagesPieData.concat(this.content.platforms.map((element) => {
        return [this.platformTypes.find(platform => platform.key.includes(element.platform)).name, element.total]
      }))

      this.platformColors = []
      this.platformMessagesPieData.forEach(element => {
        let color = this.platformTypes.find(platform => platform.name === element[0])
        if (color) {
          this.platformColors.push(color.color)
        }
      })
    },
    cutTableText (text) {
      return Strings.cutStringByScreenWidth(text)
    },
    showKpiAgentsView () {
      this.$emit('showKpiAgentsView')
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Analytics/Charts.vue